import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { MdLocationOn, MdEmail, MdPhone } from "react-icons/md";

export default function ContactUsContent() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, []);

  if (!ready) {
    return (
      <div className="container py-5 text-center">
        {getInlineLoader()}
      </div>
    );
  }

  return (
    <section
      className="MainBodySection bg-secondary"
      style={{ paddingTop: "80px", paddingBottom: "90px" }}
    >
      <div className="container">

        {/* Header */}
        <div className="text-center mb-5">
          <h1 className="main-section-title text-light">Contact Us</h1>
          <p
            className="text-light"
            style={{ maxWidth: "680px", margin: "0 auto", opacity: 0.9 }}
          >
            Reach Ndomano Group of Companies through the official channels below.
          </p>
        </div>

        {/* Contact Cards */}
        <div className="row justify-content-center g-4">

          {/* Address */}
          <div className="col-md-4">
            <div className="card border-0 shadow-sm h-100 text-center">
              <div className="card-body p-4">
                <div className="mb-3 text-primary fs-2">
                  <MdLocationOn />
                </div>
                <h6 className="fw-bold mb-2">Location</h6>
                <p className="text-muted mb-0">Dar es Salaam, Tanzania</p>
              </div>
            </div>
          </div>

          {/* Email */}
          <div className="col-md-4">
            <div className="card border-0 shadow-sm h-100 text-center">
              <div className="card-body p-4">
                <div className="mb-3 text-primary fs-2">
                  <MdEmail />
                </div>
                <h6 className="fw-bold mb-2">Email</h6>
                <a
                  href="mailto:info@ndomanogroup.com"
                  className="text-muted text-decoration-none"
                >
                  info@ndomanogroup.com
                </a>
              </div>
            </div>
          </div>

          {/* Phone & WhatsApp */}
          <div className="col-md-4">
            <div className="card border-0 shadow-sm h-100 text-center">
              <div className="card-body p-4">
                <div className="mb-3 text-primary fs-2">
                  <MdPhone />
                </div>
                <h6 className="fw-bold mb-2">Phone & WhatsApp</h6>

                <a
                  href="tel:+255772162151"
                  className="text-muted text-decoration-none d-block mb-1"
                >
                  +255 772 162 151
                </a>
                <a
                  href="https://wa.me/255772162151"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-success text-decoration-none d-block mb-2"
                >
                  WhatsApp
                </a>

                <a
                  href="tel:+255749487578"
                  className="text-muted text-decoration-none d-block mb-1"
                >
                  +255 749 487 578
                </a>
                <a
                  href="https://wa.me/255749487578"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-success text-decoration-none d-block"
                >
                  WhatsApp
                </a>
              </div>
            </div>
          </div>

        </div>

        {/* Soft CTA */}
        <div className="text-center mt-5">
          <button
            onClick={() => appContext.navTo({ item: "" })}
            className="btn btn-outline-light px-4"
          >
            Back to Home
          </button>
        </div>

      </div>
    </section>
  );
}
